var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader",class:{'hidden': _vm.isHidden}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader ball-spin-fade-loader"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }